import type { ConferencingMeetingPlatform } from "@app/common/types";

export const LABEL_FOR_CONFERENCING_PLATFORM: Record<
  ConferencingMeetingPlatform,
  string
> = {
  meet: "Google Meet",
  teams: "Microsoft Teams",
  webex: "Webex",
  zoom: "Zoom",
};
